// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/CouponsPreviewHeader/index.jsx
import { Divider, Flex, Tag, Typography, theme } from 'antd';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import app from 'configs/ConfigIndex';

const { Text, Title } = Typography;

const dividerStyle = { margin: '24px 0 16px' };
const titleStyle = { marginBottom: 4, letterSpacing: 2 };
const tagWrapStyle = { marginBottom: 8 };
const fieldsWrapStyle = { marginTop: 16 };
const labelStyle = { fontSize: 13 };
const valueStyle = { fontSize: 13 };

const CouponsPreviewHeader = ({ selectedDocument: r }) => {
  const { token } = theme.useToken();
  const baseColor = app?.baseColor || token.colorPrimary;
  const bgBarStyle = {
    height: 56,
    marginLeft: -24,
    marginRight: -24,
    marginTop: -24,
    marginBottom: 20,
    backgroundColor: baseColor,
  };

  if (!r) return null;

  const qty = Number(r?.qty) || 0;
  const used = Number(r?.usedCount) || 0;
  const remaining = r?.__remaining != null ? r.__remaining : Math.max(0, qty - used);

  const discountLabel =
    r?.discount != null
      ? r?.type === 'value'
        ? `R$ ${r.discount}`
        : `${r.discount}%`
      : null;

  const expirationLabel = r?.expirationDate ? dayjs(r.expirationDate).format('L') : null;

  return (
    <div>
      <div style={bgBarStyle} />
      <div style={{ textAlign: 'center' }}>
        {r?.status && (
          <div style={tagWrapStyle}>
            <Tag color="blue">{translateX(r.status)}</Tag>
          </div>
        )}
        <Title level={4} style={titleStyle}>
          {r?.name ? String(r.name).toUpperCase() : '—'}
        </Title>
        <div style={fieldsWrapStyle}>
          <Flex vertical gap={4} style={{ width: '100%' }}>
            {discountLabel && (
              <InfoRow label={translateX('discount')} value={discountLabel} token={token} strong />
            )}
            {qty > 0 && (
              <InfoRow
                label={translateX('quantity')}
                value={`${remaining} / ${qty}`}
                token={token}
              />
            )}
            {expirationLabel && (
              <InfoRow
                label={translateX('expiration_date')}
                value={expirationLabel}
                token={token}
              />
            )}
          </Flex>
        </div>
        <Divider style={dividerStyle} />
      </div>
    </div>
  );
};

export default CouponsPreviewHeader;

function InfoRow({ label, value, token, strong = false }) {
  if (!value) return null;
  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    borderBottom: `1px solid ${token?.colorBorderSecondary}`,
  };
  return (
    <div style={rowStyle}>
      <Text type="secondary" style={labelStyle}>
        {label}:
      </Text>
      <Text strong={strong} style={valueStyle}>
        {value}
      </Text>
    </div>
  );
}
